import React, { useState } from 'react';
import { dataTypeEnum, saveData, getData } from 'utils';
import { EMAIL_REGEX, PHONE_REGEX } from 'config/constants';
import {
  Box,
  CircularProgress,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from '@material-ui/core';
import { HeaderParameters } from '../../../../MainArea/Parameters/components';
import { ProviderApi } from 'services';
import { useAuthFunctions } from 'contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import DefaultButton from 'components/DefaultButton';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/side-logo.svg';
import SignupFirstStep from '_assets/register/Signup-First-Step.svg';
import StepComponent from 'components/StepComponent';
import useStyles from './styles';

const steps = ['Inscription', 'Finalisation'];

const SignUp = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { signInMethodsForEmail } = useAuthFunctions();

  const savedData = getData(dataTypeEnum.userData);

  if (props.location?.state?.page === 1) props.setOauth();

  const [state, setState] = useState(props.location.state?.page || props.stepNb || 0);

  const [email, setEmail] = useState(savedData?.email || props.location.state?.email || '');
  const [password, setPassword] = useState(props.pwd || '');
  const [confirmPassword, setConfirmPassword] = useState(props.pwd || '');
  const [isSavingFirstStep, setIsSavingFirstStep] = useState(false);

  const [firstName, setFirstName] = useState(savedData?.firstName || props.location.state?.firstName || '');
  const [lastName, setLastName] = useState(savedData?.lastName || props.location.state?.lastName || '');
  const [phone, setPhone] = useState(savedData?.phone || props.location.state?.phone || '');

  const [errors, setErrors] = useState({});
  const [showGlobalError, setShowGlobalError] = useState(false);

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;

    if (name === 'userEmail') {
      setEmail(value);
    } else if (name === 'userPassword') {
      setPassword(value);
    } else if (name === 'confirmUserPassword') {
      setConfirmPassword(value);
    } else if (name === 'userFirstName') {
      setFirstName(value);
    } else if (name === 'userLastName') {
      setLastName(value);
    } else if (name === 'userPhone') {
      setPhone(value);
    }
  };

  const back = () => {
    if (props.oauth === true || props.stepNb === 0) history.goBack();
    else {
      setState(0);
      props.setStepNb(0);
    }
  };

  const validateFirstStep = async (event) => {
    event.preventDefault();

    setIsSavingFirstStep(true);
    const reg = new RegExp(EMAIL_REGEX);
    if (reg.test(email) && password.length > 5 && confirmPassword === password) {
      try {
        setErrors({});
        setShowGlobalError(false);

        const { registered } = await ProviderApi.isRegistered(email);
        const signInMethods = await signInMethodsForEmail(email);

        if (signInMethods.length !== 0 || registered) {
          setErrors({ userEmail: 'Adresse email déjà utilisée' });
          setIsSavingFirstStep(false);
        } else {
          setIsSavingFirstStep(false);
          setState(1);
          props.setStepNb(1);
        }
      } catch (error) {
        setShowGlobalError(true);
        setIsSavingFirstStep(false);
      }
    } else {
      let err = {};
      if (!reg.test(email)) err = { userEmail: 'Veuillez saisir une adresse email valide' };
      if (password.length <= 5)
        err = { ...err, userPassword: 'Votre mot de passe doit contenir au moins 6 caractères' };
      if (password !== confirmPassword) err = { ...err, confirmUserPassword: 'Le mot de passe de correspond pas' };
      setErrors(err);
      setIsSavingFirstStep(false);
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    const phoneReg = new RegExp(PHONE_REGEX);
    if (props.stepNb === 1 && firstName.length > 0 && lastName.length > 0 && phoneReg.test(phone)) {
      props.setStepNb(2);
      saveData(dataTypeEnum.userData, {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
      });
      props.setPwd(password);
      history.push(routes.register.company.root, { stepNb: props.stepNb });
    } else {
      let err = {};
      if (firstName.length < 1) err = { userFirstName: 'Veuillez saisir votre prénom' };
      if (lastName.length < 1) err = { ...err, userLastName: 'Veuillez saisir votre nom de famille' };
      if (!phoneReg.test(phone)) err = { ...err, userPhone: 'Veuillez saisir un numéro de téléphone valide' };
      setErrors(err);
    }
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={state === 0 ? SignupFirstStep : sideImage} alt="Files" width={200} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <div className={classes.stepper}>
          <Stepper activeStep={0} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <StepComponent step={index} stepNb={props.stepNb} />
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </div>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid container item justifyContent="center">
          <HeaderParameters onClick={back} text={state === 0 ? 'Vos informations' : 'Votre identité'} />

          {state === 0 ? (
            <Typography align="center" variant="h2">
              Pour commencer, sécurisons votre compte.
            </Typography>
          ) : (
            <Typography align="center" variant="h2">
              Parlons de vous ! Nous avons besoin de quelques informations pour la création de votre compte.
            </Typography>
          )}
        </Grid>

        <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
          <form
            autoComplete="off"
            className={classes.form}
            noValidate
            onSubmit={(event) => {
              state === 0 ? validateFirstStep(event) : onSubmitHandler(event);
            }}
          >
            <Grid container justifyContent="center" style={{ height: '100%' }}>
              <Grid container item xs={12} md={9} alignItems="center" justifyContent="center" style={{ flexGrow: 1 }}>
                {state === 0 ? (
                  <Box style={{ width: '100%' }}>
                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Votre email"
                      name="userEmail"
                      required
                      variant="outlined"
                      value={email}
                      onChange={onChangeHandler}
                      error={errors?.userEmail}
                      helperText={errors?.userEmail}
                    />

                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Définissez un mot de passe"
                      name="userPassword"
                      required
                      type="password"
                      variant="outlined"
                      value={password}
                      onChange={onChangeHandler}
                      error={errors?.userPassword}
                      helperText={errors?.userPassword}
                    />

                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Confirmez mot de passe"
                      name="confirmUserPassword"
                      required
                      type="password"
                      variant="outlined"
                      value={confirmPassword}
                      onChange={onChangeHandler}
                      error={errors?.confirmUserPassword}
                      helperText={errors?.confirmUserPassword}
                    />
                  </Box>
                ) : (
                  <Box style={{ width: '100%' }}>
                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Votre prénom"
                      name="userFirstName"
                      required
                      variant="outlined"
                      value={firstName}
                      onChange={onChangeHandler}
                      error={errors?.userFirstName}
                      helperText={errors?.userFirstName}
                    />

                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Votre nom"
                      name="userLastName"
                      required
                      variant="outlined"
                      value={lastName}
                      onChange={onChangeHandler}
                      error={errors?.userLastName}
                      helperText={errors?.userLastName}
                    />

                    <TextField
                      className={classes.field}
                      fullWidth
                      label="Votre numéro de téléphone"
                      name="userPhone"
                      required
                      variant="outlined"
                      value={phone}
                      onChange={onChangeHandler}
                      error={errors?.userPhone}
                      helperText={errors?.userPhone}
                    />
                  </Box>
                )}
                {showGlobalError && (
                  <Grid container justifyContent="center">
                    <Typography color="error" style={{ fontSize: 18 }}>
                      {showGlobalError}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Grid className={classes.buttonContainer} container item xs={12} alignItems="stretch">
                <Grid
                  container
                  item
                  xs={12}
                  alignItems="flex-end"
                  justifyContent="center"
                  style={{ marginBottom: '16px' }}
                >
                  <DefaultButton cancel onClick={() => history.push(routes.login.root)}>
                    Annuler
                  </DefaultButton>
                  <DefaultButton color="secondary" disabled={isSavingFirstStep} type="submit" variant="contained">
                    {isSavingFirstStep ? <CircularProgress size={20} /> : 'Valider'}
                  </DefaultButton>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default SignUp;
